import https from 'node:https'
import http from 'node:http'

function parseUrl(url) {
  const parsed = new URL(url)
  return {
    protocol: parsed.protocol,
    hostname: parsed.hostname,
    port: parsed.port,
    path: `${parsed.pathname}${parsed.search}`,
  }
}

function nodeRequest(url, options = {}) {
  const { protocol, hostname, port, path } = parseUrl(url)
  const transport = protocol === 'https:' ? https : http

  const headers = { ...(options.headers ?? {}) }
  let body = options.body

  if (body !== undefined && body !== null && typeof body !== 'string') {
    body = JSON.stringify(body)
    if (!headers['Content-Type']) {
      headers['Content-Type'] = 'application/json'
    }
  }

  const requestOptions = {
    hostname,
    port: port || (protocol === 'https:' ? 443 : 80),
    path,
    method: options.method ?? 'GET',
    headers,
    rejectUnauthorized: false,
  }

  return new Promise((resolve, reject) => {
    const req = transport.request(requestOptions, (res) => {
      let data = ''
      res.setEncoding('utf8')
      res.on('data', (chunk) => {
        data += chunk
      })
      res.on('end', () => {
        resolve({
          ok: !res.statusCode || (res.statusCode >= 200 && res.statusCode < 300),
          status: res.statusCode ?? 0,
          statusText: res.statusMessage ?? '',
          json: async () => JSON.parse(data),
          text: async () => data,
        })
      })
    })

    req.on('error', reject)
    req.setTimeout(15000, () => {
      req.destroy(new Error('timeout'))
    })

    if (body !== undefined && body !== null) {
      req.write(body)
    }
    req.end()
  })
}

export async function httpFetch(url, options = {}) {
  if (import.meta.env.SSR) {
    return nodeRequest(url, options)
  }

  return fetch(url, options)
}
